import { render, staticRenderFns } from "./objectBuy.vue?vue&type=template&id=75f74951&"
import script from "./objectBuy.vue?vue&type=script&lang=js&"
export * from "./objectBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports